import React, { forwardRef, useContext } from "react";
import PropTypes from "prop-types";
import { LpgContinueSolid } from "@/icons";

import { ThemeContext } from "../Theme";
import { Icon } from "../Icon";
import { TextLink } from "../TextLink";

import styles from "./LinkList.scss";

const LinkListLink = forwardRef(({ children, href, ...restProps }, ref) => {
  let theme = useContext(ThemeContext);

  if (!theme) {
    theme = "light";
  }

  return (
    <li ref={ref} className={styles.link}>
      <span className={styles["arrow-icon-wrap"]}>
        <span className={styles["arrow-icon"]}>
          <Icon
            icon={LpgContinueSolid}
            size={Icon.Size.parent}
            color={theme === "theme_dark" ? "#31C3F7" : "#00739F"}
          />
        </span>
      </span>
      <span className={styles["text-link"]}>
        <TextLink href={href} {...restProps}>
          {children}
        </TextLink>
      </span>
    </li>
  );
});

LinkListLink.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  href: PropTypes.string,
};

LinkListLink.defaultProps = {
  href: "#",
};

LinkListLink.displayName = "LinkList.Link";

export default LinkListLink;
